import { UniDriver } from '@wix/wix-ui-test-utils/dist/types/unidriver';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export type CopyClipboardUniDriver = ReturnType<
  typeof copyClipboardDriverFactory
>;

export const copyClipboardDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
  };
};
